import { DataPair, newDataPair } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/ContextData/DataPair';

export function fillObjectFromDataPairs<T = any>(target: T | null, data: DataPair[]): T {
  target = target || ({} as T);

  if (!data || data.length === 0) {
    return target;
  }

  for (let i = 0; i < data.length; i++) {
    const dp = data[i];
    if (dp.Name && dp.Name.length > 0) {
      (target as any)[dp.Name] = dp.OutputValue;
    }
  }

  return target;
}

/**
 * Creates value to update a property editor value
 * @param value new value for an editor
 */
export function createDataPairValue(value: any): DataPair {
  return newDataPair({
    Name: 'value',
    OutputValue: value,
  });
}

export function getDataPairValue<T>(pairs: DataPair | DataPair[], name: string): T | undefined {
  return Array.isArray(pairs) ? (pairs.find(pair => pair.Name === name)?.OutputValue as T) : (pairs.OutputValue as T);
}
